import { useRef } from 'react';

import { FileInput, Wrapper } from './hiddenFileUploadStyle';

interface IProps {
  name?: string;
  label?: string;
  onChange?;
}

const HiddenFileUploadView = ({ onChange, name, label }: IProps) => {
  const hiddenFileInput = useRef(null);

  return (
    <Wrapper onClick={() => hiddenFileInput.current.click()}>
      {label}

      <FileInput
        name={name}
        type="file"
        ref={hiddenFileInput}
        onChange={(e) => onChange(e.target.files[0])}
      />
    </Wrapper>
  );
};

export default HiddenFileUploadView;
